import { render } from "./StandardQuestion.vue?vue&type=template&id=a20aa614&scoped=true"
import script from "./StandardQuestion.vue?vue&type=script&lang=js"
export * from "./StandardQuestion.vue?vue&type=script&lang=js"

import "./StandardQuestion.vue?vue&type=style&index=0&id=a20aa614&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a20aa614"]])

export default __exports__